module.exports = __webpack_public_path__ + "ba5a08a8a3359bd97c46bac9bbecb0a0.svg";